import { render, staticRenderFns } from "./ShCard.md?vue&type=template&id=6ff9e888"
import script from "./ShCard.md?vue&type=script&lang=js"
export * from "./ShCard.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports